import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../programsdash/ProgramsDash.css";
import Menu from "../../components/menu/Menu";
import "./Clients.css";
import CompanyClientsList from "../../components/companyclientslist/CompanyClientList";
import { Context } from "../../context/Context";

const Clients = (props) => {

  const {clientsData, setClientsData, contentClientsLoaded, setContentClientsLoaded} = useContext(Context);

  const [selectedTab, setSelectedTab] = useState("Clients");
  // const [clientsData, setClientsData] = useState([]);
  // eslint-disable-next-line
  const [loading, setLoading] = useState(false);
  // const [contentClientsLoaded, setContentClientsLoaded] = useState(false);
  const [search, setSearch] = useState("");
  const searchClients = useRef("");
  const [isSorted, setSorted] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
  const [companyDeleteId, setCompanyDeleteId] = useState(0);
  const [succPopUp, setSuccPopUp] = useState(false);
  const [clientDel, setClientDel] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem("disableUnLoad");
    localStorage.removeItem("ExerBuilderEdited");
  }, [])

  const popupRef = useRef(succPopUp);
  useEffect(() => {
    popupRef.current = succPopUp;
    const timeout = setTimeout(() => {
      setSuccPopUp(false);
      setClientDel(false);
    }, 5000);
    return () => {
      clearTimeout(timeout);
    };
  }, [succPopUp]);

  useEffect(() => {
    props.actSidebar(true);
    const currentUserData = JSON.parse(localStorage.getItem("userData"));
    if (currentUserData === null) {
      props.checkLoggedIn(false);
    } else {
      setLoading(true);
      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(window.ajaxLink + "cloud_therapist/getCompanyClients", {
          search,
          selectedTab,
        })
        .then((res) => {
          if (res.data.responseData) {
            setLoading(false);
            setClientsData(res.data.responseData);
            setContentClientsLoaded(true);
            if (JSON.parse(localStorage.getItem("newClientAdded")) !== null) {
              setSuccPopUp("Client has been created.");
              localStorage.removeItem("newClientAdded");
            }
            if (JSON.parse(localStorage.getItem("newClientEdited")) !== null) {
              setSuccPopUp("Client updated successfully.");
              localStorage.removeItem("newClientEdited");
            }
          }
        })
        .catch((error) => {
          console.error(error);
          if (error.response.data.responseCode === 400 || error.response.data.responseCode === 401) {
            props.checkLoggedIn(false);
          } else if (error.response.data.responseCode === 417) {
            setClientsData([]);
          }
        });
    }
    // eslint-disable-next-line
  }, [search, selectedTab]);

  const updateSearchQuery = (value) => {
    if (value && value.length >= 3) {
      setSearch(value);
    } else if (value === "") {
      setSearch("");
    }
  };

  const handleModal = (i) => {
    const data = [...clientsData];
    for (let m of data) {
      m.modalOpened = false;
    }
    let toggle = data[i].modalOpened;
    data[i].modalOpened = !toggle;
    setClientsData(data);
  };

  const handleDeleteModal = (id) => {
    setModalVisible(true);
    const data = [...clientsData];
    for (let m of data) {
      m.modalOpened = false;
    }
    setClientsData(data);
    setCompanyDeleteId(id);
  };

  const closeDeleteModal = () => {
    setModalVisible(false);
  };

  const closeDotModal = () => {
    const data = [...clientsData];
    for (let m of data) {
      m.modalOpened = false;
    }
    setClientsData(data);
  };

  const updateClientData = (data) => {
    setClientsData(data);
  };
  const handleDeleteClient = () => {
    setLoading(true);
    axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
    axios
      .post(window.ajaxLink + "cloud_therapist/delete-client-data", { companyDeleteId })
      .then((res) => {
        if (res.data.responseData) {
          setLoading(false);
          setModalVisible(false);
          setClientsData(res.data.responseData);
          setContentClientsLoaded(true);
          setSuccPopUp("Client has been deleted successfully.");
          setClientDel(true);
        }
      })
      .catch((error) => {
        console.error(error);
        if (error.response.data.responseCode === 400 || error.response.data.responseCode === 401) {
          props.checkLoggedIn(false);
        }
      });
  };

  const handleSorting = (column, array) => {
    if (!isSorted) {
      var sorted = [...array].sort(function (a, b) {
        if (a[column] < b[column]) {
          return -1;
        }
        if (a[column] > b[column]) {
          return 1;
        }
        return 0;
      });
      setSorted(true);
    } else {
      sorted = [...array].sort(function (a, b) {
        if (a[column] > b[column]) {
          return -1;
        }
        if (a[column] < b[column]) {
          return 1;
        }
        return 0;
      });
      setSorted(false);
    }
    setClientsData(sorted);
  };

  // eslint-disable-next-line
  const handleSelectedTab = (tab) => {
    setSelectedTab(tab);
    setContentClientsLoaded(false);
  };

  return (
    <div>
      <Menu title={"Clients"} />
      <div className="programs_dash_hold">
        {/* <div className="programs_dash_top_hold">
          <div className="programs_dash_top_options">
            <div className="programs_dash_contain_opts">
              <div
                className={"programs_dash_option" + (selectedTab === "Clients" ? " p_d_option_selected" : "")}
                onClick={() => handleSelectedTab("Clients")}
                >
                  Clients
                </div>
              </div>
            <div className={"p_d_selected_slide" + (selectedTab === "Clients" ? "" : " slide_opt_2")}></div>
          </div>
          <div
            className="programs_new_btn"
            onClick={() => {
              navigate("/add-new-client");
              props.actSidebar(false);
            }}
          >
            Add Client
          </div>
        </div> */}
        <div className="table_component_container" style={{paddingTop: '10px'}}>
        {selectedTab === "Clients" && (
          <CompanyClientsList
            clientsData={clientsData}
            search={searchClients}
            updateSearchQuery={updateSearchQuery}
            handleSorting={handleSorting}
            contentLoaded={contentClientsLoaded}
            selectedTab={selectedTab}
            modalOpened={handleModal}
            handleDeleteModal={handleDeleteModal}
            closeDeleteModal={closeDeleteModal}
            modalVisible={modalVisible}
            handleDeleteClient={handleDeleteClient}
            closeDotModal={closeDotModal}
            updateClientData={updateClientData}
            actSidebar={props.actSidebar}
          />
        )}
        </div>
        {succPopUp && (
          <div className="prog_err_hold prog_pop_pat_correct">
            <div className="prog_pop_icon_correct prog_err_icon"></div>
            <div className="prog_err_text prog_pop_text_correct">{succPopUp}</div>
          </div>
        )}
        {succPopUp && clientDel && (
          <div className="prog_err_hold prog_pop_pat_correct">
            <div className="prog_pop_icon_correct prog_err_icon"></div>
            <div className="prog_err_text prog_pop_text_correct">{succPopUp}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Clients;
